import {
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../../constants/app-constant";
const { V_BLOG, V_FORUM, V_BLOGS_AND_FORUMS } = VERTICALS;

export const blogsAndForumSOVWidgetList = [
  {
    type: V_BLOG,
    name: "RANKING BY COMPANY",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOVNOARanking,
        vertical: [V_BLOGS_AND_FORUMS, V_BLOG],
      },
    ],
  },
  {
    type: V_BLOG,
    name: "TREND BY COMPANY",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOV_NOA_TREND,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "RANKING BY COMPANY",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOVNOARanking,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "TREND BY COMPANY",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOV_NOA_TREND,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];

export const blogsAndForumWordCloudWidgetList = [
  {
    type: V_BLOG,
    name: "Keyword cloud",
    graph_type: GRAPH_TYPES.WORD_CLOUD,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.KeywordCloudNOA,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "Keyword cloud",
    graph_type: GRAPH_TYPES.WORD_CLOUD,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.KeywordCloudNOA,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];

export const blogsAndForumLanguageWidgetList = [
  {
    type: V_BLOG,
    name: "Top Languages",
    graph_type: GRAPH_TYPES.DOUGHNUT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TopLanguages,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "Top Languages",
    graph_type: GRAPH_TYPES.DOUGHNUT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TopLanguages,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];

export const blogsAndForumTagWidgetList = [
  {
    type: V_BLOG,
    name: "Tag Analysis",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TagBasedTagAnalysis,
        vertical: [V_BLOGS_AND_FORUMS, V_BLOG],
      },
    ],
  },
  {
    type: V_BLOG,
    name: "Tag Analysis By Entity",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.EntityBasedTagAnalysis,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "Tag Analysis",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TagBasedTagAnalysis,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "Tag Analysis By Entity",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.EntityBasedTagAnalysis,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];

export const blogsAndForumCityWidgetList = [
  {
    type: V_BLOG,
    name: "World Map",
    graph_type: GRAPH_TYPES.CHOROPLETH,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.WorldMap,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "World Map",
    graph_type: GRAPH_TYPES.CHOROPLETH,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.WorldMap,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];

export const blogsAndForumSentimentWidgetlist = [
  {
    type: V_BLOG,
    name: "TONALITY BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TonalityNAORanking,
        vertical: [V_BLOG, V_BLOGS_AND_FORUMS],
      },
    ],
  },
  {
    type: V_FORUM,
    name: "TONALITY BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TonalityNAORanking,
        vertical: [V_FORUM, V_BLOGS_AND_FORUMS],
      },
    ],
  },
];
